import { useEffect, useState } from "react";
import { LoadPanelFullScreen } from "../_components/LoadPanel/LoadPanelFullScreen";
import { deleteAuthentication } from "../_helpers/token";
import { useHistory } from "react-router-dom";
import notify from "devextreme/ui/notify";

const Logout = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    notify("Wylogowano Poprawnie", "success", 5000);
    deleteAuthentication();
    setLoading(false);
    history.push("/login");
  }, []);

  return <LoadPanelFullScreen visible={loading} />;
};

export { Logout };
